<template>
    <div class="team-member-sod-eod-report">
        <v-container fluid class="pa-6">
            <v-btn text small color="primary" class="mb-2" :to="{ name: 'TeamSodEodReview' }">
                <v-icon left small>mdi-arrow-left</v-icon>
                Back to Team Overview
            </v-btn>
            <SodEodFullReport v-if="targetUserId" :user-id="targetUserId" :user-name="targetUserName" />
        </v-container>
    </div>
</template>

<script>
import SodEodFullReport from '../../components/modules/SodEodFullReport.vue';

export default {
    name: 'TeamMemberSodEodReport',
    components: {
        SodEodFullReport,
    },
    inject: {
        users: { from: 'users', default: () => () => [] },
    },
    computed: {
        targetUserId() {
            const id = Number(this.$route.params.userId);
            return Number.isInteger(id) && id > 0 ? id : null;
        },
        targetUser() {
            return (this.users() || []).find((u) => u.id === this.targetUserId) || null;
        },
        targetUserName() {
            return this.targetUser ? this.targetUser.name : '';
        },
    },
};
</script>
